export const SYSTEM_DOCS_CATEGORIES = {
  PRIVACY: 'policy',
  EULA: 'eula',
  TERMS: 'terms_of_use',
  RELEASE_NOTES: 'release_notes',
  FAQ: 'faq',
  TRADEMARKS: 'trademarks',
} as const;